<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Usuários</h1>
        <paragrafo>
          Aqui é possível buscar os usuários cadastrados para a loja ou
          cadastrar novos. Para buscar um usuário, ou seja, alguma pessoa que
          tenha o cadastro de administrador/funcionário vinculado à loja, basta
          selecionar o cadastro desta pessoa clicando no lápis.
        </paragrafo>
        <imagem :src="image_1" />
        <ul class="mt-5">
          <li>Para criar um novo cadastro, clique em "Novo Cadastro";</li>
          <li>Preencher todos os campos obrigatórios;</li>
          <li>Status: Ativo.</li>
        </ul>
        <paragrafo>
          <ul>
            <li>
              Perfil <negrito>LOJISTA</negrito> - Este campo deve ser marcado
              apenas para os usuários que forem utilizar o ambiente de lojista e
              acessar os relatórios.
            </li>
            <li>
              Perfil <negrito>APP</negrito> - será usado para acesso ao app
              Eleven360 Validator pelo usuário. Este campo deve ser marcado
              apenas para os usuários que forem validar/queimar os ingressos
              durante o evento.
            </li>
            <li>
              Perfil <negrito>ADMIN</negrito> - Perfil que contempla os acessos
              dos perfis de Lojista e App, concedendo acesso à todo o ambiente
              lojista e também a queima de ingressos pelo app.
            </li>
          </ul>
        </paragrafo>
        <imagem :src="image_2" />
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "name",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/documentacao/usuarios/usuarios1.png",
      image_2: "/documentacao/usuarios/usuarios2.png",
    };
  },
};
</script>
